/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.kit.KitImportMode
*/
export var KitImportMode;
(function (KitImportMode) {
    KitImportMode["INSTALL"] = "INSTALL";
    KitImportMode["UPDATE"] = "UPDATE";
    KitImportMode["APPLY"] = "APPLY";
})(KitImportMode || (KitImportMode = {}));
//# sourceMappingURL=KitImportMode.js.map